export default class Data {

  SECTIONS = [
    'printed_graphics',
    'printed_graphics_variants',
    'printed_graphics_series',
    'color_graphics',
    'color_graphics_series',
    'paintings',
    'sketches',
    'news',
    'exhibitions',
    'photos',
    'texts_by_aksinin',
    'articles_about_aksinin',
    'bibliography',
    'art_milieu',
  ]

  PAGES = [
    'biography',
    'autobiography',
  ]

  constructor(data) {
    this.data              = data
    this.sections          = []
    this.gallery_sections  = []
    this.image_sections    = []
    this.photo_sections    = []
    this.archive_sections  = []
    this.document_sections = []
    this.catalog_sections  = []
    this.pages             = []
    Object.keys(data).forEach(key => {
      if (this.SECTIONS.includes(key)) {
        let section = new Section(key, data[key], data)
        this[key] = section
        this.sections.push(section)
        if (section.gallery_url) {
          this.gallery_sections.push(section)
        }
        if (section.image_url) {
          this.image_sections.push(section)
        }
        if (section.photo_url) {
          this.photo_sections.push(section)
        }
        if (section.archive_url) {
          this.archive_sections.push(section)
        }
        if (section.document_url) {
          this.document_sections.push(section)
        }
        if (section.catalog_url) {
          this.catalog_sections.push(section)
        }
      } else if (this.PAGES.includes(key)) {
        let page = new Page(key, data)
        this[key] = page
        this.pages.push(page)
      } else {
        this[key] = data[key]
      }
    })
    this.addItemURLs()
    this.addImageURLs()
    this.addAttachmentURLs()
    this.addSearchTerms()
    this.resolveForeignKeys()
    this.addUnfinishedAndSeries()
    this.groupRelatedWorks()
  }

  getSection(section) {
    return this[this.underscores(section)]
  }

  getItem(section, item) {
    return this.getSection(section).getItem(item)
  }

  underscores(string) {
    return string.replace(/-/g, '_')
  }

  addItemURLs() {
    this.sections.forEach(section => section.fields.includes('uid') && section.items.forEach(item => {
      if (section.item_url) {
        item.url = section.item_url.replace(':item', item.uid)
      } else if (section.gallery_url) {
        item.url = section.gallery_url.replace(':series', item.uid)
      }
      if (item.image) {
        item.thumb_url = `${this.media_host}${section.tag}/${item.image}_t.jpg`
      }
      if (item.youtube_id) {
        item.thumb_url = `https://img.youtube.com/vi/${item.youtube_id}/default.jpg`
      }
    }))
  }

  addImageURLs() {
    this.sections.forEach(section => section.fields.includes('hash') && section.items.forEach((image, n) => {
      if (image.hash) {
        image.large_url = `${this.media_host}${section.tag}/${image.hash}.jpg`
        image.small_url = `${this.media_host}${section.tag}/${image.hash}_s.jpg`
        image.thumb_url = `${this.media_host}${section.tag}/${image.hash}_t.jpg`
      } else {
        image.small_url = this.media_host + 'variant-preview.jpg'
        image.thumb_url = this.media_host + 'variant-thumbnail.jpg'
      }
      if (!section.key.endsWith('variants')) {
        image.prev = n > 0 && section.items[n-1]
        image.next = n < section.items.length-1 && section.items[n+1]
      }
    }))
  }

  addAttachmentURLs() {
    this.sections.forEach(section => section.fields.includes('attachments') && section.items.forEach(item => {
      item.attachments.forEach((attachment, n) => {
        attachment.url = section.attachment_url.replace(':item', item.uid).replace(':attachment', attachment.uid)
        if (attachment.extension) {
          attachment.large_url = `${this.media_host}${section.tag}/${attachment.hash}${attachment.extension}`
        } else if (attachment.hash) {
          attachment.large_url = `${this.media_host}${section.tag}/${attachment.hash}.jpg`
          attachment.small_url = `${this.media_host}${section.tag}/${attachment.hash}_s.jpg`
          attachment.thumb_url = `${this.media_host}${section.tag}/${attachment.hash}_t.jpg`
        } else if (attachment.youtube_id) {
          attachment.thumb_url   = `https://img.youtube.com/vi/${attachment.youtube_id}/default.jpg`
          attachment.youtube_url = `https://www.youtube.com/embed/${attachment.youtube_id}`
        }
        attachment.prev = n > 0 && item.attachments[n-1]
        attachment.next = n < item.attachments.length-1 && item.attachments[n+1]
      })
    }))
  }

  addSearchTerms() {
    this.sections.forEach(section => section.items.forEach(item => {
      item.search = [
        item.name        ? item.name.toLowerCase()        : '',
        item.title       ? item.title.toLowerCase()       : '',
        item.description ? item.description.toLowerCase() : '',
        item.content     ? item.content.toLowerCase()     : '',
        item.caption     ? item.caption.toLowerCase()     : '',
        item.text        ? item.text.toLowerCase()       : '',
      ].join('')
    }))
  }

  resolveForeignKeys() {
    this.sections.forEach(section => Object.keys(section.foreign_keys).length > 0 && section.items.forEach(item => {
      Object.keys(section.foreign_keys).forEach(fk => {
        item[fk] = item[fk].map(uid => this.getItem(section.foreign_keys[fk], uid))
      })
    }))
  }

  addUnfinishedAndSeries() {
    let unfinished = []
    this.printed_graphics.items = this.printed_graphics.items.filter(image => {
      if (!isNaN(+image.name[0])) {
        return true
      }
      unfinished.push(image)
      if (image.next) {
        image.next.prev = image.prev
      }
      if (image.prev) {
        image.prev.next = image.next
      }
      image.next = image.prev = undefined
      return false
    })
    this.printed_graphics.unfinished = unfinished
    this.printed_graphics.series     = this.printed_graphics_series
    this.color_graphics.series       = this.color_graphics_series
  }

  groupRelatedWorks() {
    this.printed_graphics.items.forEach(image => {
        if (image.variants && image.variants.length > 0 && image.sketches && image.sketches.length > 0) {
            image.variants.push('separator')
            image.variants = image.variants.concat(image.sketches)
            image.sketches = undefined
        }
    })
    this.sketches.items.forEach(sketch => {
        let relatedWorks = []
        let keys         = ['printed_graphics', 'color_graphics', 'paintings']
        keys.forEach(key => {
            if (sketch[key] && sketch[key].length > 0) {
                if (relatedWorks.length > 0) {
                    relatedWorks.push('separator')
                }
                relatedWorks = relatedWorks.concat(sketch[key])
                sketch[key]  = undefined
            }
        })
        sketch.relatedWorks = relatedWorks
    })
  }

  parseURL(token) {
    let m = token.match(/^([^:]*?)(?::([^:]*?))?(?::([^:]*?))?$/) // section | section:item | section:item:attachment
    let section = m && m[1] && this.getSection(m[1])
    if (!section) {
      return '/'
    }
    let item = m[2] && section.getItem(m[2])
    if (!item) {
      return section.url
    }
    let attachment = m[3] && item.getAttachment(m[3])
    if (!attachment) {
      return item.url
    }
    return attachment.url
  }

}

class Section {

  FOREIGN_KEYS = {
    'variants'         : key => key + '_variants',
    'originals'        : key => key.slice(0, -'_variants'.length),
    'sketches'         : key => 'sketches',
    'printed_graphics' : key => 'printed_graphics',
    'color_graphics'   : key => 'color_graphics',
    'paintings'        : key => 'paintings',
    'series'           : key => key + '_series',
    'images'           : key => key.slice(0, -'_series'.length),
  }

  URLS = {
    'gallery'    : 'gallery_url',
    'image'      : 'image_url',
    'photo'      : 'photo_url',
    'archive'    : 'archive_url',
    'document'   : 'document_url',
    'attachment' : 'attachment_url',
    'catalog'    : 'catalog_url',
  }

  constructor(key, items, data) {
    this.key         = key
    this.tag         = key.replace(/_/g, '-')
    this.title       = data.content[key + '_title']
    this.description = data.content[key + '_description']
    this.by_uid      = {}
    if (items[0] && items[0].items) {
      this.categories = items
      this.items      = this.categories.map(category => category.items).reduce((all, items) => all.concat(items), [])
    } else {
      this.items = items
    }
    this.items = this.items.map(item => {
      item.section = this
      item.by_uid  = {}
      item.attachments && item.attachments.forEach(attachment => {
        attachment.item             = item
        item.by_uid[attachment.uid] = attachment
      })
      item.getAttachment = uid => item.by_uid[uid]
      return item
    })
    this.fields = (this.items[0] && Object.keys(this.items[0])) || []
    this.fields.includes('uid') && this.items.forEach(item => {
      this.by_uid[item.uid] = item
    })
    this.foreign_keys = {}
    Object.keys(this.FOREIGN_KEYS).forEach(fk => {
      if (this.fields.includes(fk)) {
        this.foreign_keys[fk] = this.FOREIGN_KEYS[fk](this.key)
      }
    })
    let urls = data.urls[key]
    urls && Object.keys(this.URLS).forEach(key => {
      this[this.URLS[key]] = urls[key]
    })
    this.url      = this.gallery_url || this.archive_url
    this.item_url = this.image_url || this.photo_url || this.document_url
    if (this.catalog_url) {
      this.catalog_title              = data.content[key + '_catalog_title']
      this.catalog_description        = data.content[key + '_catalog_description']
      this.catalog_prolog             = data.content[key + '_catalog_prolog']
      this.catalog_unfinished_title   = data.content[key + '_catalog_unfinished_title']
      this.catalog_series_title       = data.content[key + '_catalog_series_title']
      this.catalog_series_description = data.content[key + '_catalog_series_description']
    }
  }

  getItem(uid) {
    return this.by_uid[uid]
  }

}

class Page {
  
  constructor(key, data) {
    this.key         = key
    this.url         = data.urls[key]
    this.title       = data.content[key + '_title']
    this.description = data.content[key + '_description']
    this.heading     = data[key].title
    this.content     = data[key].content
    this.white       = data[key].white
  }

}



// WEBPACK FOOTER //
// ./src/data.js